import React, {useState} from "react";
import {Col, FormGroup, Row} from "reactstrap";
import Accordion from "react-bootstrap/Accordion";
import Select from "react-select";
import Switch from "react-switch";
import ScrollArea from "react-scrollbar";

const SmartReportFilter = ({moduleFilters, settings, extraFilters, setExtraFilters, onClearFilters}) => {

    const getOptions = (filter) => {
        if (filter.options) return filter.options;
        if (filter.type === 'setting' || filter.type === 'setting_code') {
            const data = settings[filter.setting_key] || [];
            return data.map(item => ({
                value: filter.type === 'setting_code' ? item[filter.value_field || 'code'] : String(item.id),
                label: item.name || item.shop_name,
            }));
        }
        return [];
    };

    const selectFilters = moduleFilters.filter(f => f.type !== 'toggle');
    const toggleFilters = moduleFilters.filter(f => f.type === 'toggle');

    return (
        <div style={{height: '1000'}}>
            <ScrollArea horizontal={false} vertical={true}>
                <Accordion style={{marginBottom: '60px'}} defaultActiveKey={['0', '1']} alwaysOpen className="custom-accordion">
                    {selectFilters.length > 0 && (
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>Filters</Accordion.Header>
                            <Accordion.Body>
                                {selectFilters.map((filter) => {
                                    const options = getOptions(filter);
                                    return (
                                        <Row className="mt-3" key={filter.key}>
                                            <Col md="12">
                                                <Select
                                                    getOptionLabel={(option) => option.label}
                                                    getOptionValue={(option) => option.value}
                                                    className="select2-filter"
                                                    menuPortalTarget={document.body}
                                                    styles={{menuPortal: base => ({...base, zIndex: 100})}}
                                                    value={extraFilters[filter.key] ? options.find(o => o.value === extraFilters[filter.key]) || null : null}
                                                    onChange={(e) => {
                                                        setExtraFilters(prev => ({...prev, [filter.key]: e ? e.value : null}));
                                                    }}
                                                    isClearable={true}
                                                    placeholder={filter.label}
                                                    components={{IndicatorSeparator: () => null}}
                                                    filterOption={(option, inputValue) =>
                                                        option.data.label.toLowerCase().includes(inputValue.toLowerCase())
                                                    }
                                                    options={options}
                                                />
                                            </Col>
                                        </Row>
                                    );
                                })}
                            </Accordion.Body>
                        </Accordion.Item>
                    )}
                    {toggleFilters.length > 0 && (
                        <Accordion.Item eventKey="1">
                            <Accordion.Header>Options</Accordion.Header>
                            <Accordion.Body>
                                <Row>
                                    {toggleFilters.map((filter) => (
                                        <Col md={6} className="mt-3" key={filter.key}>
                                            <label style={{marginTop: 8, marginLeft: 4, fontSize: '13px'}}>{filter.label}</label>
                                            <FormGroup style={{marginTop: 1, marginLeft: 4}}>
                                                <Switch
                                                    checked={!!extraFilters[filter.key]}
                                                    onChange={(checked) => {
                                                        setExtraFilters(prev => ({...prev, [filter.key]: checked ? 1 : null}));
                                                    }}
                                                    className="react-switch"
                                                    uncheckedIcon={false}
                                                    checkedIcon={false}
                                                />
                                            </FormGroup>
                                        </Col>
                                    ))}
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>
                    )}
                </Accordion>
            </ScrollArea>
        </div>
    );
};

export default SmartReportFilter;
